<div class="content">
  <div class="file-upload-wrapper">
    <div class="file-format">
      <span>File size limit: 1 GB.</span>
      <span class="format-separator">|</span>
      <span
        >Supported formats: doc, xlsx, xls, xlsm, odt, pdf, txt, docx, zip,
        csv</span
      >
    </div>
    <div class="file-upload-box">
      <div
        class="file-info-text"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [class.drag-over]="isDragOver"
      >
        @if (!file) {
          <div class="svg-holder">
            <app-svg-icon
              [iconName]="'upload.svg'"
              [height]="'100px'"
              [width]="'100px'"
            ></app-svg-icon>
          </div>
        }

        @if (file && validationErrors.length === 0) {
          <div class="selected-file-info">
            <span>{{ file.name }}</span>
            <a
              class="remove-file"
              href="javascript:void(0)"
              (click)="removeFile()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </a>
          </div>
        } @else {
          <div class="file-upload-instructions">
            <span>Drag and drop your file here</span>
            <span class="or">or</span>
            <a
              href="javascript:void(0)"
              (click)="uploadFileClicked()"
              class="click-here-text"
              >Click here to select file</a
            >
          </div>
        }
      </div>
      @if (validationErrors.length > 0) {
        <div class="file-errors">
          <div class="error-file-name">Failed: {{ file?.name }}</div>
          <div class="error-list">
            @for (error of validationErrors; track $index) {
              <div class="each-error">
                @if (error === "Missing columns:") {
                  <span class="text">{{ error }}</span>
                } @else {
                  <span class="dots"></span>
                  <span class="text">{{ error }}</span>
                }
              </div>
            }
          </div>
        </div>
      }
      <div class="file-upload-button-wrapper">
        @if (uploadingFile) {
          <span class="status-text">Uploading ...</span>
        } @else {
          @if (isValidFile && visibleOperations.length > 0) {
            <div class="file-operations-head-text">
              Choose your preferred file operations:
            </div>

            <div class="file-operations">
              @for (operation of visibleOperations; track $index) {
                <div class="operation-item">
                  <label class="checkbox-container">
                    <input
                      type="checkbox"
                      [checked]="
                        selectedOperationIds.includes(operation.operation_id)
                      "
                      (change)="
                        onOperationChange($event, operation.operation_id)
                      "
                    />
                    <span class="checkmark"></span>
                    <span class="label-text">{{
                      operation.operation_name
                    }}</span>
                  </label>
                </div>
              }
            </div>
          }
          @if (isValidFile) {
            <div class="consent-checkboxes-container">
              <div class="consent-checkbox">
                <label>
                  <input type="checkbox" [(ngModel)]="hasConsentChecked" />
                  <span>
                    By uploading this document, you verify that you have the
                    proper rights and permissions to upload, share, or view this
                    document. The information in this file is up to date,
                    accurate, and does not contain any illegal or malicious
                    contents.
                  </span>
                </label>
              </div>

              <div class="consent-checkbox">
                <label>
                  <input type="checkbox" [(ngModel)]="hasTermsChecked" />
                  <span>
                    I agree to the ACC Data Hub
                    <a
                      href="/terms-of-use"
                      target="_blank"
                      (click)="$event.stopPropagation()"
                      >Terms Of Use</a
                    >.
                  </span>
                </label>
              </div>
            </div>
          }
          <a
            href="javascript:void(0)"
            class="upload-btn"
            [class.disabled]="
              !isValidFile || !hasConsentChecked || !hasTermsChecked
            "
            (click)="
              hasConsentChecked && hasTermsChecked && isValidFile
                ? uploadFileToAzure()
                : null
            "
            >Upload</a
          >
        }
      </div>
      @if (isUploadSuccess !== null) {
        <div class="file-upload-status">
          @if (isUploadSuccess) {
            <svg
              class="success-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
              />
            </svg>
            <span>Upload started successfully! You can close this window.</span>
          } @else {
            <svg
              class="failure-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
              />
            </svg>
            <span>Upload failed!</span>
          }
        </div>
      }
    </div>
  </div>
  <input
    type="file"
    #inputFile
    (change)="onFileSelect($event)"
    accept=".doc,.docx,.xlsx,.xls,.xlsm,.odt,.pdf,.txt,.zip,.csv"
    hidden
  />
</div>
